import { Country, GenderType, IdCardType } from './Enums';


export class RegisterVerificationModel {

    public constructor(init?: Partial<Pick<RegisterVerificationModel, keyof RegisterVerificationModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    email: string;
    
    phoneCountry: string;
    phone: string;

    requestAt: Date;

    codeConfirmation: string;
}

export class RegisterModel {

    public constructor(init?: Partial<Pick<RegisterModel, keyof RegisterModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number; // Solo se utiliz para devolverlo al cliente

    email: string;
    password: string;

    name: string;
    lastName: string;

    phoneCountry: string;
    phone: string;

    requestAt: Date;
    codeConfirmation: string;
    inviteCode: string;

    birthDate: Date;
    genderType: GenderType;
    province: number;
    canton: number;

    idCardType: IdCardType;
    idCard: string;

    country = Country.CR;
}

export class RegisterAccountModel {

    public constructor(init?: Partial<Pick<RegisterAccountModel, keyof RegisterAccountModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;

    firstName: string;
    lastName: string;
    birthDate: Date;
    genderType: GenderType;
    idCardType: IdCardType;
    idCard: string;
    phone: string;
    phoneCountry: string;
}

export class RegisterAddressModel {

    public constructor(init?: Partial<Pick<RegisterAddressModel, keyof RegisterAddressModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;

    province: string;
    canton: string;
    distric: string;
}

export class RegisterPhoneModel {

    public constructor(init?: Partial<Pick<RegisterPhoneModel, keyof RegisterPhoneModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    code: string;
    phoneCountry: string;
    phone: string;
    phoneVerifiedAt: Date;
    requestAt: Date;
}

export class RegisterEmailModel {

    public constructor(init?: Partial<Pick<RegisterEmailModel, keyof RegisterEmailModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    code: string;
    email: string;
    emailVerifiedAt: Date;
    requestAt: Date;
}


export class PaymentResultModel {

    currentDay: number;
    daysToPay: number;
    paymentDay: number;
    paymentMonth: number;
    paymentYear: number;
    pricePerDay: number;
    priceTotal: number;

    get tax(): number {

        const tax = this.priceTotal * 0.13;
        return tax;
    }

    get total(): number {

        return this.priceTotal;
    }
}

export class CardPaymentModel {

    public constructor(init?: Partial<Pick<CardPaymentModel, keyof CardPaymentModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    expiry: string;
    cardname: string;
    // Con Stripe son solo los últimos 4 dígitos: el número completo se queda en el
    // navegador y el backend lo rechaza si le llega entero.
    number: string;
    cvc: string;
    companyId: number;

    // Solo con Stripe: payment method (pm_xxx) y marca que devuelve Stripe.js.
    // Con ONVO quedan vacíos y el backend tokeniza a partir del número.
    token: string;
    brand: string;

    allowSaveCard: boolean = false;
}
